import * as Sentry from '@sentry/browser';
import { BrowserTracing } from '@sentry/browser';

module.exports = function (dsn, release) {
	window.iq = window.iq || {};
	window.iq.release = release;
	Sentry.init({
		dsn,
		release,
		environment: document.location.hostname,
		integrations: [new BrowserTracing()],

		// Set tracesSampleRate to 1.0 to capture 100%
		// of transactions for performance monitoring.
		tracesSampleRate: 0.5
	});

	if (window.iq.sentry_user) {
		Sentry.setUser(window.iq.sentry_user);
	}

	window.onerror = function (msg, url, line, col, err) {
		if (typeof err === 'undefined') {
			Sentry.captureException(new Error(`${msg} (no stack trace available)`));
		} else {
			Sentry.captureException(err);
		}
	};
};
